var _PhotoServiceInit_CHUNK_SIZE, _PhotoServiceInit_loader, _PhotoServiceInit_photos, _PhotoServiceInit_query, _PhotoServiceInit_nextStart, _PhotoServiceInit_loading;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { writable } from 'svelte/store';
import { VegaPhotoLoader } from '../../model/photo/loader/VegaPhotoLoader';
class PhotoServiceInit {
    constructor() {
        _PhotoServiceInit_CHUNK_SIZE.set(this, 100);
        _PhotoServiceInit_loader.set(this, new VegaPhotoLoader());
        _PhotoServiceInit_photos.set(this, writable([]));
        _PhotoServiceInit_query.set(this, '');
        _PhotoServiceInit_nextStart.set(this, 0);
        _PhotoServiceInit_loading.set(this, false);
    }
    get photos() {
        return __classPrivateFieldGet(this, _PhotoServiceInit_photos, "f");
    }
    async init(query) {
        __classPrivateFieldSet(this, _PhotoServiceInit_loading, true, "f");
        __classPrivateFieldSet(this, _PhotoServiceInit_query, query, "f");
        const photos = await __classPrivateFieldGet(this, _PhotoServiceInit_loader, "f").load({
            q: query,
            start: 0,
            length: __classPrivateFieldGet(this, _PhotoServiceInit_CHUNK_SIZE, "f"),
        });
        __classPrivateFieldGet(this, _PhotoServiceInit_photos, "f").set(photos);
        __classPrivateFieldSet(this, _PhotoServiceInit_nextStart, __classPrivateFieldGet(this, _PhotoServiceInit_CHUNK_SIZE, "f"), "f");
        __classPrivateFieldSet(this, _PhotoServiceInit_loading, false, "f");
    }
    async loadMore() {
        if (__classPrivateFieldGet(this, _PhotoServiceInit_loading, "f")) {
            return;
        }
        __classPrivateFieldSet(this, _PhotoServiceInit_loading, true, "f");
        const photos = await __classPrivateFieldGet(this, _PhotoServiceInit_loader, "f").load({
            q: __classPrivateFieldGet(this, _PhotoServiceInit_query, "f"),
            start: __classPrivateFieldGet(this, _PhotoServiceInit_nextStart, "f"),
            length: __classPrivateFieldGet(this, _PhotoServiceInit_CHUNK_SIZE, "f"),
        });
        __classPrivateFieldGet(this, _PhotoServiceInit_photos, "f").update((it) => [...it, ...photos]);
        __classPrivateFieldSet(this, _PhotoServiceInit_nextStart, __classPrivateFieldGet(this, _PhotoServiceInit_nextStart, "f") + __classPrivateFieldGet(this, _PhotoServiceInit_CHUNK_SIZE, "f"), "f");
        __classPrivateFieldSet(this, _PhotoServiceInit_loading, false, "f");
    }
    addPhoto(photo) {
        __classPrivateFieldGet(this, _PhotoServiceInit_photos, "f").update((it) => [photo, ...it]);
    }
}
_PhotoServiceInit_CHUNK_SIZE = new WeakMap(), _PhotoServiceInit_loader = new WeakMap(), _PhotoServiceInit_photos = new WeakMap(), _PhotoServiceInit_query = new WeakMap(), _PhotoServiceInit_nextStart = new WeakMap(), _PhotoServiceInit_loading = new WeakMap();
export const PhotoService = new PhotoServiceInit();
